import { Component, OnInit } from '@angular/core';
import { IReportData, IReportMetadata, IReportResponse, ReportDataService } from '../../../shared/report/report-data.service';
import * as _ from 'underscore';
import { IObject } from '../../../../type_definitions/datatypes';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { IUserData } from '../../../shared/services/auth/auth-data.service';

import { UserProfileService } from '../user-profile.service';
import { BrowseListConfigService, IBrowselistActionPermission, IBrowseListConfig } from '../../../shared/browselists/browselists-config.service';

export const USER_TRAINING_REPORT_ID: number = 314;

@Component({
  selector: 'user-training',
  template: `
    <h2 translate>APP.USER_PROFILE.USER_TRAINING.TITLE</h2>

    <div class="col-space-top">
      <embedded-report
        [browselistConfig]="userTrainingBrowselistConfig"
        [browselistContext]="userProfileId"
        [newLabel]="'APP.USER_PROFILE.USER_TRAINING.REQUEST_TRAINING' | translate"
        [reportMetadata]="reportMetadata"
        [reportDataLoading]="reportDataLoading"
        [reportData]="reportData"
        [queryFilters]="reportQueryFilters"
        [browselistActionPermission]="permissions"
        [showActions]="true">
      </embedded-report>
    </div>
  `
})
export class UserTrainingComponent implements OnInit {
  public reportMetadata: IReportMetadata;
  public reportDataLoading: boolean;
  public reportData: IReportData;
  public reportQueryFilters: IObject = {};
  public permissions: IBrowselistActionPermission;
  public userProfileId: number;
  public userTrainingBrowselistConfig: IBrowseListConfig;

  private userData: IUserData;

  constructor(
    private reportDataService: ReportDataService,
    private authService: AuthService,
    private userProfileService: UserProfileService,
    browselistConfigService: BrowseListConfigService
  ) {
    this.userTrainingBrowselistConfig = browselistConfigService.getConfig('USER_TRAINING');
  }

  public ngOnInit(): void {
    // get user data
    this.userData = this.authService.getCurrentUser();
    this.userProfileId = this.userProfileService.getUserProfileId();

    // permissions for request training button
    const isACSLUserOrThemselves: boolean = this.authService.checkAcslUser() || (this.userData?.id === this.userProfileId);
    this.permissions = {
      // request training / see ticket only for ACSL user or themselves
      add: isACSLUserOrThemselves,
      edit: isACSLUserOrThemselves
    };

    // set report query filters
    this.reportQueryFilters = {
      Contact_id: this.userProfileId
    };

    // get report metadata
    this.initUserTrainingReport();
  }

  private initUserTrainingReport(): void {
    this.reportDataLoading = true;

    this.reportDataService.loadMetaData(USER_TRAINING_REPORT_ID)
      .then((metadata: IReportMetadata) => {
        this.reportMetadata = _.clone(metadata);

        return metadata;
      })
      .then(this.loadReportData)
      .finally(() => {
        this.reportDataLoading = false;
      });
  }

  private loadReportData = (): Promise<IReportResponse> => {
    return this.reportDataService.loadData(USER_TRAINING_REPORT_ID.toString(), USER_TRAINING_REPORT_ID, this.reportQueryFilters)
      .then((res: IReportResponse) => {
        this.reportData = _.clone(res?.data);

        return res;
      });
  };
}